import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (sectionId) => {
    if (location.pathname === "/") {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${sectionId}`);
    }
    setIsMenuOpen(false);
  };

  const goToServices = () => {
    navigate("/services");
    setIsMenuOpen(false);
  };

  const goHome = (e) => {
    e.preventDefault();
    navigate("/");
    setIsMenuOpen(false);
  };

  return (
    <header className="navigation-header">
      <div className="container">
        <div className="header-content">
          <a href="/" onClick={goHome} className="navigation-logo-container">
            <img
              src="/images/modern-elegant-logo.png"
              alt="'Alohi - Skin & Wellness"
              className="navigation-logo-image"
              style={{ width: "auto", height: "150px", transform: "scale(1)" }}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="navigation-menu">
            <button
              onClick={() => goToSection("story")}
              className="navigation-link"
              data-testid="nav-story"
            >
              Our Story
            </button>
            <button
              onClick={goToServices}
              className={`navigation-link ${location.pathname === "/services" ? "is-active" : ""}`}
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => goToSection("products")}
              className="navigation-link"
              data-testid="nav-products"
            >
              Products
            </button>
            <button
              onClick={() => goToSection("reviews")}
              className="navigation-link"
              data-testid="nav-reviews"
            >
              Reviews
            </button>
            <a
              href="/journal/"
              className="navigation-link"
              data-testid="nav-journal"
            >
              Journal
            </a>
            <a
              href="/press/"
              className="navigation-link"
              data-testid="nav-press"
            >
              Press
            </a>
            <button
              onClick={() => goToSection("contact")}
              className="navigation-link"
              data-testid="nav-contact"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <button
              onClick={() => goToSection("story")}
              className="mobile-menu-link"
              data-testid="mobile-nav-story"
            >
              Our Story
            </button>
            <button
              onClick={goToServices}
              className="mobile-menu-link"
              data-testid="mobile-nav-services"
            >
              Services
            </button>
            <button
              onClick={() => goToSection("products")}
              className="mobile-menu-link"
              data-testid="mobile-nav-products"
            >
              Products
            </button>
            <button
              onClick={() => goToSection("reviews")}
              className="mobile-menu-link"
              data-testid="mobile-nav-reviews"
            >
              Reviews
            </button>
            <a
              href="/journal/"
              className="mobile-menu-link"
              data-testid="mobile-nav-journal"
            >
              Journal
            </a>
            <a
              href="/press/"
              className="mobile-menu-link"
              data-testid="mobile-nav-press"
            >
              Press
            </a>
            <a
              href="/partners/"
              className="mobile-menu-link"
              data-testid="mobile-nav-partners"
            >
              Partners
            </a>
            <button
              onClick={() => goToSection("contact")}
              className="mobile-menu-link"
              data-testid="mobile-nav-contact"
            >
              Contact
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
